// Saglasnost za kolačiće i učitavanje Google AdSense skripta.
// Oglasi se prikazuju samo ako je podešen REACT_APP_ADSENSE_CLIENT i korisnik je dao saglasnost.

export type ConsentValue = 'granted' | 'denied';

// Neophodni kolačići su uvek uključeni; korisnik bira samo analitiku i oglase (marketing).
export type ConsentPrefs = { analytics: boolean; ads: boolean };

const CONSENT_KEY = 'cookieConsent';
const PREFS_KEY = 'cookiePrefs';
export const CONSENT_EVENT = 'cookie-consent-changed';
export const OPEN_COOKIE_SETTINGS_EVENT = 'open-cookie-settings';

export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || '';

export type AdPlacement = 'home' | 'lista' | 'lekcija';

const ADSENSE_SLOTS: Record<AdPlacement, string> = {
    home: process.env.REACT_APP_ADSENSE_SLOT_HOME || '',
    lista: process.env.REACT_APP_ADSENSE_SLOT_LISTA || '',
    lekcija: process.env.REACT_APP_ADSENSE_SLOT_LEKCIJA || '',
};

export const getAdSlot = (placement: AdPlacement) => ADSENSE_SLOTS[placement];

export const getConsentPrefs = (): ConsentPrefs | null => {
    try {
        const raw = localStorage.getItem(PREFS_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            return { analytics: !!parsed.analytics, ads: !!parsed.ads };
        }
        // stari izbor (sve ili ništa) pre uvođenja kategorija
        const legacy = localStorage.getItem(CONSENT_KEY);
        if (legacy === 'granted' || legacy === 'denied') {
            const granted = legacy === 'granted';
            return { analytics: granted, ads: granted };
        }
        return null;
    } catch {
        return null;
    }
};

// 'granted' samo ako je korisnik dozvolio oglase (koristi AdSlot)
export const getConsent = (): ConsentValue | null => {
    const prefs = getConsentPrefs();
    if (!prefs) return null;
    return prefs.ads ? 'granted' : 'denied';
};

const toGoogle = (value: boolean) => (value ? 'granted' : 'denied');

const updateGoogleConsent = (prefs: ConsentPrefs) => {
    const gtag = (window as any).gtag;
    if (typeof gtag !== 'function') return;
    gtag('consent', 'update', {
        analytics_storage: toGoogle(prefs.analytics),
        ad_storage: toGoogle(prefs.ads),
        ad_user_data: toGoogle(prefs.ads),
        ad_personalization: toGoogle(prefs.ads),
    });
};

export const setConsentPrefs = (prefs: ConsentPrefs) => {
    try {
        localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
        localStorage.removeItem(CONSENT_KEY);
    } catch {
        // privatni režim / blokiran storage - saglasnost važi samo za ovu sesiju
    }
    updateGoogleConsent(prefs);
    window.dispatchEvent(new Event(CONSENT_EVENT));
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));

let adsenseLoaded = false;

export const loadAdsenseScript = () => {
    if (!ADSENSE_CLIENT || adsenseLoaded) return;
    adsenseLoaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
};
